import { render } from "./Cgv.vue?vue&type=template&id=043d3263"
import script from "./Cgv.vue?vue&type=script&lang=js"
export * from "./Cgv.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__